/**
 * Типы отложенных действий синхронизации (очередь SyncActionsTable, обрабатывается background-sync).
 * Реально в очередь ставятся ТОЛЬКО {@code signDay} (подпись конца дня) и {@code endOrder} (завершение
 * заявки); {@code startDay} и {@code updateRTS} нигде не ставятся — оставлены на будущее (см. разбор
 * default-ветки в background-sync).
 */
export enum SyncAction {
  startDay = 'startDay',
  endOrder = 'endOrder',
  updateRTS = 'updateRTS',
  signDay = 'signDay'
}
